import { render } from "./CBoatSpecifications.vue?vue&type=template&id=9bc9ff76&scoped=true"
import script from "./CBoatSpecifications.vue?vue&type=script&lang=js"
export * from "./CBoatSpecifications.vue?vue&type=script&lang=js"

import "./CBoatSpecifications.vue?vue&type=style&index=0&id=9bc9ff76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bc9ff76"]])

export default __exports__